import { render, staticRenderFns } from "./course-icon.vue?vue&type=template&id=aa40d1e6&"
import script from "./course-icon.vue?vue&type=script&lang=js&"
export * from "./course-icon.vue?vue&type=script&lang=js&"
import style0 from "./course-icon.vue?vue&type=style&index=0&id=aa40d1e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports